"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tester = exports.notTester = exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _react2 = require("@jsonforms/react");

var _core = require("@jsonforms/core");

var _ACLHeader = _interopRequireDefault(require("../ACLHeader"));

var _excluded = ["schema"],
    _excluded2 = ["acl"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

// TODO: from translations
var t = {
  ON_REQUEST: 'enkel op aanvraag',
  PRIVATE: 'enkel voor medewerkers',
  PUBLIC: 'publiek',
  REGISTERED: 'enkel wanneer aangemeld'
};

var renderer = function renderer(_ref) {
  var schema = _ref.schema,
      props = _objectWithoutProperties(_ref, _excluded);

  var acl = schema.acl,
      restOfSchema = _objectWithoutProperties(schema, _excluded2);

  var label = "".concat(props.label, " (").concat(schema.acl, ")");
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_react2.ResolvedJsonFormsDispatch, _extends({}, props, {
    schema: _objectSpread(_objectSpread({}, restOfSchema), {}, {
      dontSkip: true
    }),
    label: label
  })), /*#__PURE__*/_react["default"].createElement(_ACLHeader["default"], {
    header: t[acl.toUpperCase()],
    acl: acl.toUpperCase(),
    labels: {
      acl: t
    }
  }));
};

var tester = (0, _core.rankWith)(4, (0, _core.and)( // isNumberControl,
(0, _core.schemaMatches)(function (schema) {
  var acl = schema.hasOwnProperty('acl');
  return acl;
})));
exports.tester = tester;
var notTester = (0, _core.rankWith)(5, (0, _core.schemaMatches)(function (schema) {
  return !schema.hasOwnProperty('acl') && !schema.hasOwnProperty('dontSkip');
}));
exports.notTester = notTester;

var _default = (0, _react2.withJsonFormsControlProps)(renderer);

exports["default"] = _default;